import {
  Component,
  EventEmitter,
  Input,
  Output,
  AfterViewInit,
} from '@angular/core';
import { FormioUtils } from 'angular-formio';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';
import { Subscription } from 'rxjs';
import { FormObserverService } from 'src/app/formiobuilder/services/form-observer.service';

@Component({
  selector: 'app-commercial-line-item',
  templateUrl: './commercial-line-item.component.html',
  styleUrls: ['./commercial-line-item.component.scss'],
})
export class CommercialLineItemComponent implements AfterViewInit {
  @Input() value: object;
  @Output() valueChange = new EventEmitter<object>();
  @Input() name: string;

  data: any;
  isLoading: boolean = true;

  @AutoUnsubscribe()
  private castFormData$: Subscription;

  constructor(private formObserverService: FormObserverService) {}

  ngAfterViewInit(): void {
    this.name = this.name.replace('data[', '').replace(']', '');
    let result = [];
    this.castFormData$ = this.formObserverService.castFormData.subscribe(
      (formData: any) => {
        result = FormioUtils.searchComponents(formData, {
          type: 'commercialLineItem',
          key: this.name,
        });
      }
    );

    setTimeout(() => {
      if (result.length) {
        this.data = {
          Description: result[0]?.productDescription,
          Label: result[0]?.productName,
          Amount: result[0]?.amount,
          Dynamic: result[0]?.dynamic,
          TotalAmount: result[0]?.amount * result[0]?.quantity,
          Quantity: result[0]?.quantity,
          TaxValueType: result[0]?.taxType === 'USD' ? 'taxAmount' : 'taxRate',
          TaxAmount: result[0]?.taxType === 'USD' ? result[0]?.taxValue : null,
          TaxRate:
            result[0]?.taxType === 'PERCENT' ? result[0]?.taxValue : null,
          TaxType: result[0]?.taxIndicator,
          ProductCode: result[0]?.purchaseId,
          ItemCommodityCode: result[0]?.commodityCode,
          UnitOfMeasure: result[0]?.unitOfMeasure,
          DiscountType:
            result[0]?.discount === 'USD' ? 'discountAmount' : 'discountRate',
          DiscountAmount:
            result[0]?.discount === 'USD' ? result[0]?.discountValue : null,
          DiscountRate:
            result[0]?.discount === 'PERCENT' ? result[0]?.discountValue : null,
          TaxTreatment: result[0]?.taxTreatment,
          HideLabel: result[0]?.hideLabel,
          HideQuantity: result[0]?.hideQuantity,
          HideDescription: result[0]?.hideDescription,
        };
        this.updateValue(this.data);
        this.isLoading = false;
      }
    }, 300);
  }

  updateData() {
    this.updateValue({
      ...this.data,
      TotalAmount: this.data.Quantity * this.data.Amount,
    });
  }

  updateValue(payload: object) {
    this.value = payload; // Should be updated first
    this.valueChange.emit(payload); // Should be called after this.value update
  }
}
